import React from "react";
import { motion } from "framer-motion";
import { scrollToId } from "./fx";

export const Nav = ({ t }) => (
  <motion.nav
    initial={{ opacity: 0, y: -16 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: 0.5, duration: 0.7 }}
    className="fixed top-4 left-1/2 -translate-x-1/2 z-50 flex items-center gap-1 md:gap-2 px-2 py-2 rounded-full glass-card"
    data-testid="floating-nav"
  >
    <button data-testid="nav-learn-link" onClick={() => scrollToId("learn")} className="mono text-[10px] tracking-[0.2em] text-white/60 hover:text-[#4D9FFF] transition-colors px-3 py-2">{t.nav.learn}</button>
    <button data-testid="nav-host-link" onClick={() => scrollToId("host")} className="mono text-[10px] tracking-[0.2em] text-white/60 hover:text-[#4D9FFF] transition-colors px-3 py-2">{t.nav.host}</button>
    <button data-testid="nav-faq-link" onClick={() => scrollToId("faq")} className="mono text-[10px] tracking-[0.2em] text-white/60 hover:text-[#4D9FFF] transition-colors px-3 py-2">{t.nav.faq}</button>
    <button data-testid="nav-register-cta" onClick={() => scrollToId("register")} className="btn-accent mono text-[10px] tracking-[0.2em] px-4 py-2 rounded-full">{t.nav.register}</button>
  </motion.nav>
);
